import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-5 py-20 text-center">
      <XCircle className="h-14 w-14 text-muted-foreground" />
      <h1 className="mt-6 font-heading text-2xl font-bold">Payment canceled</h1>
      <p className="mt-2 text-muted-foreground">
        No worries — nothing was charged. Your slot is still open if you'd like to try again.
      </p>
      <Link to="/booking" className="mt-8 inline-flex rounded-xl bg-primary px-7 py-3.5 font-bold text-primary-foreground transition-all hover:-translate-y-0.5 hover:brightness-110">
        Back to Booking
      </Link>
    </div>
  );
}
